export const ITALY = {
  id: 110,
  value: "Italy",
};
